// extracted by mini-css-extract-plugin
export default {"root":"ListingSkeleton-module-root","imageSkeleton":"ListingSkeleton-module-imageSkeleton"};